import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Select } from 'foundations-components/transitional/components/Select';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WidthMeasurer = styled.div.withConfig({
  displayName: "DynamicWidthSelect__WidthMeasurer",
  componentId: "tn7dka-0"
})(["position:absolute;white-space:nowrap;height:0;visibility:hidden;opacity:0;"]);
const DynamicWidthSelect = ({
  value,
  onChange,
  options,
  dataTestId
}) => {
  const [width, setWidth] = useState(0);
  const [measurerNode, setMeasurerNode] = useState(null);
  useEffect(() => {
    if (measurerNode) {
      setWidth(measurerNode.offsetWidth);
    }
  }, [value, measurerNode]);
  const ButtonContent = ({
    buttonText
  }) => /*#__PURE__*/_jsx(Text, {
    typography: "heading-50",
    children: /*#__PURE__*/_jsx(TruncateString, {
      tooltip: buttonText,
      placement: "top",
      children: buttonText
    })
  });
  const valueLabel = useMemo(() => {
    var _options$find;
    return (_options$find = options.find(option => option.value === value)) === null || _options$find === void 0 ? void 0 : _options$find.text;
  }, [options, value]);
  return /*#__PURE__*/_jsxs(View, {
    position: "relative",
    overflow: "hidden",
    "data-test-id": "dynamic-width-select",
    maxInlineSize: width > 0 ? `${width + 15}px` : 'auto',
    children: [/*#__PURE__*/_jsx(Select, {
      menuWidth: 'auto',
      multi: false,
      anchorType: "button",
      buttonUse: "unstyled",
      placement: "bottom",
      value: value,
      searchable: false,
      onChange: onChange,
      options: options,
      "data-test-id": dataTestId,
      ButtonContent: ButtonContent
    }), /*#__PURE__*/_jsx(WidthMeasurer, {
      ref: setMeasurerNode,
      children: /*#__PURE__*/_jsx(Text, {
        typography: "heading-50",
        children: valueLabel
      })
    })]
  });
};
export default DynamicWidthSelect;